import { render, staticRenderFns } from "./PostFormAddon.vue?vue&type=template&id=2694231c"
import script from "./PostFormAddon.vue?vue&type=script&lang=ts"
export * from "./PostFormAddon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports